export const buttonOptions = [
  {
    value: "(",
    view: "(",
  },
  {
    value: ")",
    view: ")",
  },
  {
    value: "%",
    view: "%",
  },
  {
    value: "clear",
    view: "clear",
  },
  {
    value: "7",
    view: "7",
    class: "number",
  },
  {
    value: "8",
    view: "8",
    class: "number",
  },
  {
    value: "9",
    view: "9",
    class: "number",
  },
  {
    value: "*",
    view: "X",
  },
  {
    value: "4",
    view: "4",
    class: "number",
  },
  {
    value: "5",
    view: "5",
    class: "number",
  },
  {
    value: "6",
    view: "6",
    class: "number",
  },
  {
    value: "/",
    view: "÷",
  },
  {
    value: "1",
    view: "1",
    class: "number",
  },
  {
    value: "2",
    view: "2",
    class: "number",
  },
  {
    value: "3",
    view: "3",
    class: "number",
  },
  {
    value: "+",
    view: "+",
  },
  {
    value: ".",
    view: ".",
    class: "number",
  },
  {
    value: "0",
    view: "0",
    class: "number",
  },
  {
    value: "=",
    view: "=",
    class: "equal",
  },
  {
    value: "-",
    view: "-",
  },
];
